import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, Input } from '@angular/core';
import { DetalleSolicitud } from '../../../core/model/detalle-solicitud';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { SolicitudesService } from '../../../core/services/solicitudes.service';

@Component({
  selector: 'app-motivos',
  templateUrl: './motivos.component.html',
  styleUrls: ['./motivos.component.css'],
  providers: [SolicitudesService]
})

export class MotivosComponent implements OnInit, OnDestroy, AfterViewChecked {

  @Input() solicitud: DetalleSolicitud;

  isDocoutUser: boolean;
  clientname: string;

  constructor(
    private authService: AuthenticationService,
    private cdRef: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.SetEnviroment();
  }

  ngOnDestroy() {
    this.authService = null;
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  SetEnviroment() {
    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
      });

    this.authService.getClienteName$().subscribe(data => {
      this.clientname = data;
    });
  }

}
